import React from 'react';

/**
 * Tableaux de dimensions d'un produit : en-têtes rouges, ✓ = disponible.
 * header : lignes d'en-tête, chaque cellule est un texte ou { label, colSpan, rowSpan }
 * rows : lignes de données, la première colonne sert d'intitulé de ligne
 */
const SpecTables = ({ tables }) => (
  <div className="mb-8">
    <h3 className="text-xl font-bold text-gray-900 mb-4">Tableaux des dimensions</h3>
    <div className="space-y-8">
      {tables.map((table, tableIndex) => (
        <div key={tableIndex}>
          {table.title && (
            <h4 className="text-lg font-semibold text-red-700 mb-2">{table.title}</h4>
          )}
          {table.notes && (
            <ul className="space-y-1 mb-4">
              {table.notes.map((note) => (
                <li key={note} className="flex items-start space-x-3 text-gray-700">
                  <span className="w-1.5 h-1.5 bg-red-600 rounded-full mt-2.5 flex-shrink-0"></span>
                  <span>{note}</span>
                </li>
              ))}
            </ul>
          )}
          <div className="overflow-x-auto border border-gray-200 shadow-sm">
            <table className="min-w-full text-sm text-center border-collapse">
              <thead className="bg-red-600 text-white">
                {table.header.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => {
                      const { label, colSpan, rowSpan } = typeof cell === 'string' ? { label: cell } : cell;
                      return (
                        <th
                          key={cellIndex}
                          colSpan={colSpan}
                          rowSpan={rowSpan}
                          scope="col"
                          className="px-4 py-3 font-semibold whitespace-nowrap border border-red-500"
                        >
                          {label}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.rows.map((row, rowIndex) => (
                  <tr key={rowIndex} className="odd:bg-white even:bg-gray-50 hover:bg-red-50 transition-colors">
                    {row.map((value, cellIndex) => cellIndex === 0 ? (
                      <th key={cellIndex} scope="row" className="px-4 py-2.5 font-semibold text-gray-900 whitespace-nowrap border border-gray-200">
                        {value}
                      </th>
                    ) : (
                      <td key={cellIndex} className="px-4 py-2.5 text-gray-700 border border-gray-200">
                        {value === '✓' ? (
                          <span className="text-red-600 font-bold" aria-label="Disponible">✓</span>
                        ) : value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SpecTables;
